import { EOL } from './../components/layout-header/index';
export enum PATH_ROUTING {
    PATH_TRAINING_DOCUMENT = 'application-training-document',
    PATH_APPLICATION_CATALOG = 'application-catalog',
    PATH_REGISTER = 'request-ge-single-sign',
    PATH_SRM = 'srm',
    PATH_SRM_HOME_PAGE = 'home-page',
    PATH_ADMIN = 'admin',
    PATH_WELCOME_MESSAGE = 'welcome-message',
    PATH_SECTION = 'section',
    PATH_SUPPIER_USER = 'supplier-user',
    PATH_DASHBOARD = 'dashboard',
    PATH_NEWS = 'news',
    PATH_ROLES = 'roles',
    PATH_SCORECARD = 'score-card',
    PATH_ADD_SUPPIER_USER = 'add-new-supplier',
    PATH_EDIT_SUPPIER_USER = 'edit-supplier/:id',
    PATH_ADD_SECTION = 'add-section',
    PATH_EDIT_SECTION = 'edit-section/:id',
    PATH_APPLICATION_LINK = 'application-link/:sectionId',
    PATH_ADD_APPLICATION_LINK = 'add-application-link/:sectionId',
    PATH_EDIT_APPLICATION_LINK = 'edit-application-link/:sectionId/:id',
    PATH_INTERNAL_USER = 'internal-user',
    PATH_CONTRACT_ACCESS = 'contract-access',
    PATH_DOCSTORE_ACCESS = 'docstore-access',
    PATH_ADD_INTERNAL_USER = 'add-internal-user',
    PATH_EDIT_INTERNAL_USER = 'edit-internal-user/:id',
    PATH_ADD_CONTRACT_ROLE = 'edit-contract-access',
    PATH_EDIT_CONTRACT_ROLE = 'edit-contract-access/:id',
    PATH_ADD_DOCSTORE_ROLE = 'edit-docstore-access',
    PATH_EDIT_DOCSTORE_ROLE = 'edit-docstore-access/:id',
    PATH_ADD_NEWS = 'add-news',
    PATH_EDIT_NEWS = 'edit-news/:id',
    PATH_NEWS_ID = 'news/:id',
    PATH_APPICATION_ACCESS_STATUS = 'application-access-status',
    PATH_REVOKE_ACCESS_ID = 'revoke-access/:id',
    PATH_REVOKE_ACCESS = 'revoke-access',
    PATH_ADD_ROLE = 'add-role',
    PATH_EDIT_ROLE = 'edit-role/:id',
    PATH_APPLICATION_ACCESS_ASSIGNMENT = 'application-access-assignment',
    PATH_APPLICATION_REVOKE_ASSIGNMENT = 'application-revoke-assignment',
    PATH_TRAINING_DOCUMENT_ADMIN = 'application-training-document-admin',
    PATH_TRAINING_DOCUMENT_ADMIN_ADD = 'add-application-training-document',
    PATH_TRAINING_DOCUMENT_ADMIN_EDIT = 'edit-application-training-document/:id',
    PATH_GE_CONFIDENTIAL_DOCUMENTS = 'ge-confidential-documents',
    PATH_GE_CONFIDENTIAL_DOCUMENTS_ADMIN = 'ge-confidential-documents-admin',
    PATH_GE_CONFIDENTIAL_DOCUMENTS_ADMIN_ADD = 'add-ge-confidential-documents',
    PATH_GE_CONFIDENTIAL_DOCUMENTS_ADMIN_EDIT = 'edit-ge-confidential-documents/:id',
    PATH_STAY_INFORMED_ADMIN = 'stay-informed-admin',
    PATH_ADD_STAY_INFORMED_ADMIN = 'add-stay-informed-admin',
    PATH_EDIT_STAY_INFORMED_ADMIN = 'edit-stay-informed-admin/:id',
    PATH_CONTRACT = 'contracts',
    PATH_DOCSTORE = 'docstore',
    PATH_VIEW_CONTRACT = ':id',
    PATH_CREATE_CONTRACT = 'create',
    PATH_EDIT_CONTRACT = ':id/edit',
    PATH_CONTRACT_DELEGATE = 'delegate',
    PATH_VIEW_DOCSTORE = ':id',
    PATH_CREATE_DOCSTORE = 'create',
    PATH_EDIT_DOCSTORE = ':id/edit',
    PATH_DOCSTORE_DELEGATE = 'delegate',
    PATH_SCORECARD_SETTING = 'scorecard-setting',
    PATH_ADD_SCORECARD_SETTING = 'add-scorecard-setting',
    PATH_EDIT_SCORECARD_SETTING = 'edit-scorecard-setting/:parentURI/:year/:gsl',
    PATH_EDIT_SCORECARD_SETTING_2 = 'edit-scorecard-setting/:parentURI/:year',
    PATH_RATING_GUIDELINE = 'upload-rating-guideline',
    PATH_LANDING_PAGE_HYDRO = 'hydro',
    PATH_GE_ADMIN_STATUES = 'ge-tag-id-status',
    PATH_GE_ADMIN_STATUS_UPDATE = 'update-status/:id',
    PATH_EOL_SETUPS = 'eol-setups',
    PATH_EOL_SETUPS_SUPPLIER_FORM = 'supplier-form',
    PATH_EOL_SETUPS_FIBERGLASS = 'fiberglass-processing-method',
    PATH_EOL = 'eol',
    PATH_EOL_DESTRUCTION_MAIN_PAGE = 'destruction',
    PATH_EOL_DESTRUCTION_ADD = 'destruction-form',
    PATH_EOL_DESTRUCTION_EDIT = 'destruction-form/:id',
    PATH_EOL_RECYCLING_MAIN_PAGE = 'recycling',
    PATH_EOL_RECYCLING_ADD = 'recycling-form',
    PATH_EOL_RECYCLING_EDIT = 'recycling-form/:id',
}

export enum DISPLAY_BREADCRUMBS {
    HOME = 'Home',
    HOME_PAGE = 'home',
    SUPPLIER = 'Suppliers',
    TRAINING_DOCUMENT = 'Application Training Documents',
    APPLICATION_CATALOG = 'Application Request Access',
    REGISTER = 'Request Ge Single Sign',
    ADMIN = 'Admin',
    ADD_ADMIN = 'Add Application Training Documents',
    EDIT_ADMIN = 'Edit Application Training Documents',
    SRM = 'Landing Page',
    SECTION = 'Quick Link Management',
    ADD_SECTION = 'Add Section',
    EDIT_SECTION = 'Edit Section',
    APPLICATION = 'Application Link',
    ADD_APPLICATION = 'Add Application Link',
    EDIT_APPLICATION = 'Update Application Link',
    SUPPLIER_USER_MANAGEMENT = 'Supplier User Management',
    ADD_SUPPLIER_USER = 'Add Supplier',
    EDIT_SUPPLIER_USER = 'Edit Supplier',
    INTERNAL_USER_USER = 'Internal User Management',
    ADD_INTERNAL_USER = 'Add Internal Supplier',
    EDIT_INTERNAL_USER = 'Edit Internal Supplier',
    CONTRACT_ACCESS = 'Contract Access Management',
    ADD_CONTRACT_ACCESS = 'Add Contract Access Management',
    EDIT_CONTRACT_ACCESS = 'Edit Contract Access Management',
    DOCSTORE_ACCESS = 'DocStore Access Management',
    ADD_DOCSTORE_ACCESS = 'Add DocStore Access Management',
    EDIT_DOCSTORE_ACCESS = 'Edit DocStore Access Management',
    NEWS = 'NEWS',
    ADD_NEWS = 'Add News',
    EDIT_NEWS = 'Edit News',
    APPLICATION_ACCESS_STATUS = 'Application Sccess Status',
    REVOKE_ACCESS = 'Revoke Access',
    ROLE = 'Role',
    ADD_ROLE = 'Add role',
    EDIT_ROLE = 'Edit role',
    APPLICATION_ACCESS_ASSIGNMENT = 'Application Access Assignment',
    APPLICATION_REVOKE_ASSIGNMENT = 'Application Revoke Assignment',
    TRAINING_DOCUMENT_ADMIN = 'Training Document Admin',
    GE_CONFIDENTIAL_DOCUMENTS = 'Documents',
    GE_CONFIDENTIAL_DOCUMENTS_ADMIN = 'Documents Admin',
    ADD_GE_CONFIDENTIAL_DOCUMENTS_ADMIN = 'Add Documents',
    EDIT_GE_CONFIDENTIAL_DOCUMENTS_ADMIN = 'Edit Documents',
    STAY_INFORMED_ADMIN = 'Stay Informed Admin',
    ADD_STAY_INFORMED_ADMIN = 'Add Stay Informed Admin',
    EDIT_STAY_INFORMED_ADMIN = 'Edit Stay Informed Admin',
    SCORECARD_SETTING = 'Scorecard KPIs setting',
    ADD_SCORECARD_SETTING = 'Add Scorecard KPIs Setting',
    EDIT_SCORECARD_SETTING = 'Edit Scorecard KPIs Setting',
    RATING_GUIDELINE = 'Rating Guideline',
    GE_ADMIN_STATUES = 'GE Tag ID Statuses',
    GE_ADMIN_STATUS_UPDATE = 'GE Tag ID Update',
    EOL_SETUPS = 'EOL Setups',
    SUPPLIER_FORM = 'Supplier Form',
    FIBERGLASS_PROCESSING_FORM = 'Fiberglass Processing Form',
    EOL_FORM = 'EOL',
    EOL_DESTRUCTION = 'Destruction',
    EOL_DESTRUCTION_MAIN_PAGE = 'Destruction Main Page',
    EOL_DESTRUCTION_FORM = 'Destruction Form',
    EOL_RECYCLING = 'Recycling',
    EOL_RECYCLING_MAIN_PAGE = 'Recycling Main Page',
    EOL_RECYCLING_FORM = 'Recycling Form',
}
